exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-tileView{width:100%}@media only screen and (max-width:700px){.ba-common-tileView__asset .tileFlexLayout{justify-content:flex-start}}.ba-common-tileView__asset .ba-common-tileView__label{margin-top:24px;margin-bottom:16px;font-size:24px;font-weight:400}.ba-common-tileView__tile{margin-right:16px;margin-bottom:16px}.ba-common-tileView__loading{position:fixed;top:50%;left:50%;display:flex;justify-content:center;align-items:center}", ""]);

// exports
exports.locals = {
	"tileViewClassName": "\"ba-common-tileView\""
};